import { render, staticRenderFns } from "./area_pop_up_copy.vue?vue&type=template&id=54dbc048&scoped=true&lang=pug&"
import script from "./area_pop_up_copy.vue?vue&type=script&lang=js&"
export * from "./area_pop_up_copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dbc048",
  null
  
)

export default component.exports